import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import * as _ from 'lodash';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ScoreTrendsComponent } from '../../../../shared/components/score/score-trends/score-trends.component';
import { ScoreQuestionComponent } from '../../../../shared/components/score/score-question/score-question.component';
import { ScoreCustomComponent } from '../../../../shared/components/score/score-custom/score-custom.component';
import { ProjectScoreQuickInsightsComponent } from '../project-score-quick-insights/project-score-quick-insights.component';
import { ScoreComparisonComponent } from '../../../../shared/components/score/score-comparison/score-comparison.component';
import { ScoreTrendsNewComponent } from '../../../../shared/components/score/score-trends-new/score-trends-new.component';

@Component({
  selector: 'app-project-score-home',
  templateUrl: './project-score-home.component.html',
  styleUrls: ['./project-score-home.component.scss'],
  imports: [
    NgIf,
    NgClass,
    ScoreTrendsComponent,
    ScoreQuestionComponent,
    ScoreCustomComponent,
    ProjectScoreQuickInsightsComponent,
    ScoreComparisonComponent,
    ScoreTrendsNewComponent,
    AsyncPipe,
  ]
})

export class ProjectScoreHomeComponent implements OnInit, OnDestroy {
  // tabs = ['trends', 'questions', 'quickinsights', 'comparison'];
  tabs: any = [];
  params: any = {};
  activeTab: string = '';
  queryParams$: Observable<any> = of({});
  showTrendsTab: boolean = true;
  showComparisonTab: boolean = true;
  tabVisisblity: any = {
    trends: Helpers.isTabVisible(false, 'scores', 'summary'),
    questions: Helpers.isTabVisible(false, 'scores', 'interaction'),
    // custom: Helpers.isTabVisible(false, 'scores', 'custom'),
    quickinsights: Helpers.isTabVisible(false, 'scores', 'leaderboard'),
    comparison: Helpers.isTabVisible(false, 'scores', 'comparison'),
    trendstwo: true
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private responseAnalyticsService: ResponseAnalyticsService,
    private appStateService: AppStateService
  ) {}

  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    const mainRaterType = _.get(Helpers, 'brandDetails.main_rater_type');
    this.tabVisisblity = {
      trends: Helpers.isTabVisible(false, 'scores', 'summary'),
      questions: Helpers.isTabVisible(false, 'scores', 'interaction'),
      // custom: Helpers.isTabVisible(false, 'scores', 'custom'),
      quickinsights: Helpers.isTabVisible(false, 'scores', 'leaderboard'),
      comparison: Helpers.isTabVisible(false, 'scores', 'comparison'),
      trendstwo: true
    }

    // TODO: Temporarily hide the custom tab for non-litmusworld.com users
    let loggedInUser = _.get(Helpers, "managerDetails.manager.user_name");
    if(loggedInUser && loggedInUser.includes('@litmusworld.com')) {
      this.tabVisisblity['custom'] = Helpers.isTabVisible(false,'scores','custom');
    }

    if (this.tabVisisblity.trends && mainRaterType && mainRaterType != 2 && mainRaterType != '2') {
      this.tabs.push('trends');
    } else {
      this.showTrendsTab = false;
    }

    if (this.tabVisisblity.questions)
      this.tabs.push('questions');

    if (this.tabVisisblity.custom)
      this.tabs.push('custom');

    if (this.tabVisisblity.quickinsights)
      this.tabs.push('quickinsights');

    // Check if the 'comparison' tab should be visible and if the required dropdown conditions are met
    if (this.tabVisisblity.comparison && this.checkDropdownLengthForComparisonTab() && this.prepareCategoryDropdown()) {
      // If both conditions are true, add 'comparison' to the list of tabs and show the Comparison tab
      this.tabs.push('comparison');
      this.showComparisonTab = true;
    } else {
      // Otherwise, do not show the Comparison tab
      this.showComparisonTab = false;
    }

    if (this.tabVisisblity.trendstwo)
      this.tabs.push('trendstwo');

    if (this.tabs.indexOf('comparison') > -1 && !this.prepareCategoryDropdown()) {
      const index = this.tabs.indexOf('comparison');
      this.showComparisonTab = false;
      this.tabs.splice(index, 1);
    } else if (this.tabs.indexOf('comparison') == -1 && this.prepareCategoryDropdown()) {
      this.tabs.push('comparison');
      this.showComparisonTab = true;
    }
    if ((this.tabs && this.tabs.length) && (!this.activeTab || this.activeTab == '')) {
      this.activeTab = (this.tabs && this.tabs.length) ? this.tabs[0] : ''
      if (this.activeTab != '' && this.activeTab != null) {
        this.onClickingNavigation(this.activeTab);
      }
    }
    this.route.queryParams.subscribe(params => {
      this.params = params
      if (this.params["account_id"] && this.params["project_id"]) {
        if (this.params['active_tab'] && this.tabs.includes(this.params['active_tab'])) {
          this.activeTab = this.params['active_tab'] || this.activeTab;
          this.onClickingNavigation(this.activeTab);
        } else if (this.activeTab) {
          this.activeTab = this.activeTab;
          this.onClickingNavigation(this.activeTab);
        }
        this.prepareScalerRaterType();
      }
    });
  }

  private prepareScalerRaterType() {
    const scaleTypeId: number = _.get(Helpers, 'brandDetails.extender_rater_type') || _.get(Helpers, 'brandDetails.main_rater_type') || 0;
    if (scaleTypeId) {
      this.responseAnalyticsService.setRatingInfo(scaleTypeId);
    }
  }

  onClickingNavigation(str: string) {
    this.activeTab = str;
    this.responseAnalyticsService.switchTab(this.activeTab);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: str },
      queryParamsHandling: 'merge'
    });
  }

  /**
   * Checks if the comparison tab should be enabled based on available dropdown options
   * The tab is enabled if there are either:
   * 1. Multiple hierarchy levels available, or
   * 2. Field definitions with compare_filter or response type fields
   * @returns {boolean} true if comparison tab should be enabled, false otherwise
   */
  checkDropdownLengthForComparisonTab(): boolean {
    // Initialize array to store all available dropdown options
    let dropdown: any = [];

    // Get hierarchy list from brand details
    const hierarchyListFormBrand: any = _.get(Helpers, 'brandDetails.hierarchy_list', {});
    let hierarchyList: any = '';

    // Extract the first hierarchy list from the object
    for (let key in hierarchyListFormBrand) {
      hierarchyList = hierarchyListFormBrand[key];
    }

    // If there are multiple hierarchy levels, add them to dropdown options
    if (hierarchyList.length > 1) {
      dropdown = [...hierarchyList];
    }

    // Get field definitions and detailed feedback items from brand details
    const brandFieldDefinitions: any = _.get(Helpers, 'brandDetails.field_definitions', []);
    const brandDetailFeedbackItem: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', []);

    // If both field definitions and detailed feedback items exist
    if (brandFieldDefinitions && brandFieldDefinitions.length > 0 && brandDetailFeedbackItem && brandDetailFeedbackItem.length > 0) {
      // Add field IDs to dropdown if they are marked for comparison or are response type fields
      brandFieldDefinitions.forEach((fieldDefinition: any) => {
        if (fieldDefinition?.compare_filter || fieldDefinition?.field_type === 'response') {
          dropdown.push(fieldDefinition?.field_id)
        }
      })
    }

    // Enable comparison tab if there are any dropdown options available
    if (dropdown.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  prepareCategoryDropdown(): boolean {
    const dropdownRawData: any = [];
    const hierarchyListFormBrand: any = _.get(Helpers, 'brandDetails.hierarchy_list', {});
    let hierarchyList: any = '';
    for (let key in hierarchyListFormBrand) {
      hierarchyList = hierarchyListFormBrand[key];
    }
    const hierarchyListAliasFromBrand: any = _.get(Helpers, 'brandDetails.hierarchy_list_alias', {});
    let hierarchyListAlias: any = '';
    let hierarchyListAliasValue: any = '';
    for (let key in hierarchyListAliasFromBrand) {
      hierarchyListAliasValue = hierarchyListAliasFromBrand[key]?.name;
      hierarchyListAlias = hierarchyListAliasFromBrand[key]?.values;
    }
    if (hierarchyList && hierarchyList.length > 0 && hierarchyListAliasValue && hierarchyListAliasValue.length > 0) {
      let currentLevel: any = Helpers?.hierarchyStack;
      if (currentLevel && currentLevel.length > 0 && Helpers?.hierarchyStack && Helpers?.hierarchyStack.length > 0) {
        currentLevel = Helpers?.hierarchyStack[Helpers?.hierarchyStack.length - 1];
      }
      if (currentLevel && Object.keys(currentLevel).length > 0) {
        let currentKey: any = currentLevel?.field_id.split('_')[2];
        let createFieldId: any = currentLevel?.field_id.split('_');
        let attachCurrentFieldId: any = createFieldId[0] + '_' + createFieldId[1] + '_';
        const showAccessLevel: any = hierarchyList.slice(Number(currentKey) + 1);
        showAccessLevel.forEach((data: any) => {
          currentKey++;
          dropdownRawData.push({ name: data, field_id: attachCurrentFieldId + currentKey, field_type: 'hierarchy', category: 'Hierarchy' });
        })
      } else {
        hierarchyList.forEach((item, index) => {
          if (index > 0) {
            dropdownRawData.push({ name: item, field_id: hierarchyListAlias[index], field_type: 'hierarchy', category: 'Hierarchy' });
          }
        })
      }
    }
    const brandFieldDefinitions: any = _.get(Helpers, 'brandDetails.field_definitions', []);
    const brandDetailFeedbackItem: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', []);
    if (brandFieldDefinitions && brandFieldDefinitions.length > 0 && brandDetailFeedbackItem && brandDetailFeedbackItem.length > 0) {
      brandFieldDefinitions.forEach((fieldDefinition: any) => {
        if (fieldDefinition?.compare_filter || fieldDefinition?.field_type === 'response') {
          const nameBasedOnFieldId = _.find(brandDetailFeedbackItem, item => item.field_id === fieldDefinition?.field_id);
          dropdownRawData.push({ name: nameBasedOnFieldId?.question || nameBasedOnFieldId?.text || fieldDefinition?.name || fieldDefinition?.text || fieldDefinition?.question || fieldDefinition?.label || fieldDefinition?.field_id, field_id: fieldDefinition?.field_id, field_type: fieldDefinition?.field_type || 'tag', category: 'Cohorts' })
        }
      })
    }
    if (dropdownRawData.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}